import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const AuditorAuditsModule = lazy(loadModule);

export default AuditorAuditsModule;
